import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.5 14.482v2.108a1.403 1.403 0 0 1-1.535 1.405 13.95 13.95 0 0 1-6.075-2.157 13.7 13.7 0 0 1-4.223-4.215 13.9 13.9 0 0 1-2.161-6.091 1.4 1.4 0 0 1 .833-1.412A1.4 1.4 0 0 1 4.907 4h2.111A1.41 1.41 0 0 1 8.426 5.21c.09.674.255 1.336.493 1.974a1.4 1.4 0 0 1-.317 1.482l-.894.892a11.25 11.25 0 0 0 4.224 4.216l.894-.893a1.41 1.41 0 0 1 1.485-.316 9 9 0 0 0 1.978.492 1.41 1.41 0 0 1 1.21 1.426"
    }, null, -1)
  ]))]))
}
export default { render: render }